export const API_PARAM = {
  ADMIN_DATASETS: "admin/datasets",
  PRIMARY_TEXT_COUNT: "admin/primary-texts/count",
  PRIMARY_TEXT_GRID: "admin/primary-texts/grid",
  PRIMARY_TEXT_COL_FILTER: "admin/primary-texts/grid/values",
  PRIMARY_TEXT_EXPORT: "admin/primary-texts/export",
  PRIMARY_TEXT_UPLOAD: "admin/primary-texts/upload",
  SECONDARY_TEXT_COUNT: "admin/secondary-texts/count",
  SECONDARY_TEXT_GRID: "admin/secondary-texts/grid",
  SECONDARY_TEXT_COL_FILTER: "admin/secondary-texts/grid/values",
  SECONDARY_TEXT_EXPORT: "admin/secondary-texts/export",
  SECONDARY_TEXT_UPLOAD: "admin/secondary-texts/upload",
  NEGATIVE_TEXT_COUNT: "admin/negative-texts/count",
  NEGATIVE_TEXT_GRID: "admin/negative-texts/grid",
  NEGATIVE_TEXT_COL_FILTER: "admin/negative-texts/grid/values",
  NEGATIVE_TEXT_EXPORT: "admin/negative-texts/export",
  NEGATIVE_TEXT_UPLOAD: "admin/negative-texts/upload",
  BENCHMARK_SKILLS_COUNT:"admin/benchmark-skills/count",
  BENCHMARK_SKILLS_GRID:"admin/benchmark-skills/grid",
  BENCHMARK_SKILLS_COL_FILTER:"admin/benchmark-skills/grid/values",
  BENCHMARK_SKILLS_EXPORT:"admin/benchmark-skills/export",
  BENCHMARK_SKILLS_UPLOAD:"admin/benchmark-skills/upload",
  BENCHMARK_MICROSKILLS_COUNT:"admin/benchmark-microskills/count",
  BENCHMARK_MICROSKILLS_GRID:"admin/benchmark-microskills/grid",
  BENCHMARK_MICROSKILLS_COL_FILTER:"admin/benchmark-microskills/grid/values",
  BENCHMARK_MICROSKILLS_EXPORT:"admin/benchmark-microskills/export",
  BENCHMARK_MICROSKILLS_UPLOAD:"admin/benchmark-microskills/upload",
  BENCHMARK_JFA_COUNT:"admin/benchmark-jfa/count",
  BENCHMARK_JFA_GRID:"admin/benchmark-jfa/grid",
  BENCHMARK_JFA_COL_FILTER:"admin/benchmark-jfa/grid/values",
  BENCHMARK_JFA_EXPORT:"admin/benchmark-jfa/export",
  BENCHMARK_JFA_UPLOAD:"admin/benchmark-jfa/upload",
};
